import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  Editor,
  NgxEditorComponent,
  NgxEditorModule,
  Toolbar,
} from 'ngx-editor';
import { Output, EventEmitter, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-rich-textEditor',
  standalone: true,
  imports: [NgxEditorModule, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './rich-textEditor.component.html',
  styleUrls: ['./rich-textEditor.component.css'],
})
export class RichTextEditorComponent implements OnInit, OnDestroy, OnChanges {
  @Input() richTextValue = ''; // Pass value to this input field that will show inside the RTE
  @Input() placeHolder = 'Type Here'; // If placeholder not pass then default it will show 'type here'
  @Input() label: string; // If you want to show the label above RTE then pass label to this input field
  @Input() disable: boolean = false; // Make disable the RTE
  editor: Editor = new Editor();
  html = '';

  // Extended toolbar with all available features
  toolbar: Toolbar = [
    ['bold', 'italic', 'underline', 'strike', 'code'],
    ['blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],

    ['align_left', 'align_center', 'align_right', 'align_justify'],
    ['text_color', 'background_color'],
    ['format_clear'],
    ['undo', 'redo'],
  ];

  @ViewChild('ngxEditor', { static: true }) ngxEditor!: NgxEditorComponent;

  focusEditor() {
    // Focus the ngx-editor content
    const editorElement = this.ngxEditor.editor.view?.dom;

    if (editorElement) {
      editorElement.focus();
    }
  }

  ngOnInit(): void {
    this.editor = new Editor();
    if (this.richTextValue === null) {
      this.richTextValue = '';
    }
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }
  @Input() resetEditor = false;
  @Output() contentChange: EventEmitter<string> = new EventEmitter<string>();

  onEditorChange() {
    this.contentChange.emit(this.richTextValue);
  }
  clearEditor() {
    this.richTextValue = '';
    this.html = '';
    this.contentChange.emit(this.richTextValue); // Emit empty content to notify parent
  }

  ngOnChanges(): void {
    if (this.resetEditor) {
      this.clearEditor(); // Reset the editor when the parent sets the resetEditor flag
    }
  }
}
